import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import {
  setStep,
  setData,
  setReviewOption,
  toggleModal
} from '@store/user-review/actions';
import Icon from '@components/shared/Icon';
import { reviewFlows, reviewSteps } from '@constants/review';

const AddCureOption = ({
  title,
  label,
  type,
  condition,
  setStep,
  setData,
  setReviewOption,
  toggleModal
}) => (
  <div
    className="add-cure-option"
    onClick={() => {
      setReviewOption({
        flowType:
          type && condition ? reviewFlows.product : reviewFlows.fullProduct // show or hide type and condition selects
      });
      setData({ type, condition });
      setStep(reviewSteps.addCure);
      toggleModal();
    }}
  >
    <p className="add-cure-option__text">{title}</p>
    <p className="add-cure-option__action">
      <Icon icon="plus-slim" className="add-cure-option__icon" />
      <b>{label}</b>
    </p>
  </div>
);

AddCureOption.defaultProps = {
  title: 'Can’t find what you’re looking for?',
  label: 'Add your product or supplement'
};

AddCureOption.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.object,
  condition: PropTypes.object,
  setStep: PropTypes.func,
  setData: PropTypes.func,
  setReviewOption: PropTypes.func,
  toggleModal: PropTypes.func
};

export default connect(null, {
  setStep,
  setData,
  setReviewOption,
  toggleModal
})(AddCureOption);
